import { render, staticRenderFns } from "./welcome-expansion-panel-header.vue?vue&type=template&id=dc781b44&scoped=true&"
import script from "./welcome-expansion-panel-header.vue?vue&type=script&lang=js&"
export * from "./welcome-expansion-panel-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc781b44",
  null
  
)

export default component.exports